// https://kenwheeler.github.io/slick/

import $ from "jquery";
import "slick-carousel";

import baseClass from "../base/base";

// ------------------------------------
baseClass.OnReadyArrAdd(function () {
  // -----------------------------------

  $(".js_slick").each((_, el) => {
    const $el = $(el);
    if ($el.hasClass("slick-true")) return;
    $el.addClass("slick-true");

    // Citim opțiuni din data-* attributes
    const slidesToShow = parseInt($el.data("slidestoshow")) || 3;
    const slidesToScroll = parseInt($el.data("slidescroll")) || 1;
    const dots =
      $el.data("dots") !== undefined ? Boolean($el.data("dots")) : true;
    const infinite =
      $el.data("infinite") !== undefined ? Boolean($el.data("infinite")) : true;
    const autoplay =
      $el.data("autoplay") !== undefined
        ? Boolean($el.data("autoplay"))
        : false;
    const fade =
      $el.data("fade") !== undefined ? Boolean($el.data("fade")) : false;
    const centerMode =
      $el.data("centermode") !== undefined
        ? Boolean($el.data("centermode"))
        : false;
    const variableWidth =
      $el.data("variablewidth") !== undefined
        ? Boolean($el.data("variablewidth"))
        : false;
    const vertical =
      $el.data("vertical") !== undefined
        ? Boolean($el.data("vertical"))
        : false;
    
    const containerid = $el.data("containerid") !== undefined ? $el.data("containerid") : undefined;

    const prevArrow = (containerid != undefined) ? $('#' + containerid).find('.slick-prev') : undefined;
    const nextArrow = (containerid != undefined) ? $('#' + containerid).find('.slick-next') : undefined;

    // Responsive poate fi definit în data-responsivedef (JSON)
    let responsive = [];
    if ($el.data("responsivedef")) {
      try {
        // responsive = JSON.parse($el.data("responsivedef"));
        responsive = $el.data("responsivedef");
        // console.log("Slick :", responsive, $el.data("responsivedef"));
      } catch (err) {
        // console.warn("Slick responsive JSON invalid:", err);
        // console.log("Slick :", $el.data("responsivedef"));
      }
    }

    $el.slick({
      slidesToShow,
      slidesToScroll,
      dots,
      infinite,
      autoplay,
      fade,
      centerMode,
      variableWidth,
      vertical,
      responsive,
      prevArrow,
      nextArrow
    });
  });

  // ------------------------------------
});
